module.exports = __webpack_public_path__ + "img/apple-iphone-x.5f5ae517.png";